// postMessage bridge between the exam-taking UI and the classroom lesson
// page (spec §7 task 2-3: "テスト回答シグナル").
//
// Exam lessons render via an iframe (/embed/exams/:id -> /embed/my-exams/...)
// that is a separate browsing context: it has no other way to reach the
// meter session owned by the parent lesson page, and the parent has no way
// to observe DOM activity happening inside the iframe. This is the one
// deliberately narrow channel between them. Same-origin only (both sides are
// on the same school subdomain), scoped to a single namespaced message type
// so it can't be confused with other postMessage traffic on the page.

export const LEARNING_EVENT_MESSAGE_TYPE = "edbase:learning-event"

export interface LearningEventMessage {
  type: typeof LEARNING_EVENT_MESSAGE_TYPE
  eventType: string
}

// Native classroom exams notify the current window; legacy embeds notify their parent.
export function notifyParentOfLearningEvent(eventType: string): void {
  if (typeof window === "undefined") return

  const message: LearningEventMessage = { type: LEARNING_EVENT_MESSAGE_TYPE, eventType }
  window.parent.postMessage(message, window.location.origin)
}

// Called from the classroom lesson page. Returns a detach function.
export function bindLearningEventBridge(onEvent: (eventType: string) => void): () => void {
  const handler = (event: MessageEvent) => {
    if (event.origin !== window.location.origin) return

    const data = event.data
    if (!data || data.type !== LEARNING_EVENT_MESSAGE_TYPE || typeof data.eventType !== "string") return

    onEvent(data.eventType)
  }

  window.addEventListener("message", handler)
  return () => window.removeEventListener("message", handler)
}
